import {fontStyles, theme} from '@styles/theme';
import styled from 'styled-components';
import {StyledCheckboxProps} from './Checkbox';

export const CheckboxWrapper = styled.label<StyledCheckboxProps>`
  display: flex;
  justify-content: flex-start;
  position: relative;
  width: fit-content;
  pointer-events: ${({disabled}) => (disabled ? 'none' : 'all')};
  & > * {
    cursor: pointer;
  }
  input {
    position: absolute;
    width: 0;
    height: 0;
  }
  align-items: ${({alignCenter}) => (alignCenter ? 'center' : 'flex-start')};
`;

export const CheckboxFilledSquare = styled.div<StyledCheckboxProps>`
  display: inline-block;
  height: ${({active}: StyledCheckboxProps) => (active ? `16px` : '12px')};
  width: ${({active}: StyledCheckboxProps) => (active ? `16px` : '12px')};
  min-width: ${({active}: StyledCheckboxProps) => (active ? `16px` : '12px')};
  background: ${({active}: StyledCheckboxProps) =>
    active ? theme.colors.signalGreen00 : theme.colors.basic08};
  margin: ${({active}: StyledCheckboxProps) => (active ? 0 : '2px')};
  border: ${({active, error, squareColor}: StyledCheckboxProps) => {
    switch (true) {
      case squareColor && squareColor.length !== 0 && error && error!.length !== 0:
        return `2px solid ${theme.colors.signalRed01}`;
      case squareColor && squareColor.length !== 0 && !active:
        return `2px solid ${squareColor}`;
      case active:
        return `2px solid ${theme.colors.signalGreen01}`;
      case error && error.length !== 0:
        return `2px solid ${theme.colors.signalRed01}`;
      default:
        return `2px solid ${theme.colors.basic03}`;
    }
  }};
  border-radius: ${theme.roundedSmall};
  margin-right: ${({active, label}: StyledCheckboxProps) =>
    label ? (active ? `8px` : '10px') : '0px'};
  position: relative;
  &:before {
    width: 10px;
    height: 7px;
    ${({active}: StyledCheckboxProps) =>
      active ? `content: url(/assets/icons/checkboxMark.svg)` : `content: ''`};
    position: absolute;
    line-height: 0;
    top: ${({checkMarkPosTop}: StyledCheckboxProps) =>
      checkMarkPosTop ? `${checkMarkPosTop}%` : 'calc(50% - 3px)'};
    right: ${({checkMarkPosRight}: StyledCheckboxProps) =>
      checkMarkPosRight ? `${checkMarkPosRight}%` : '3px'};
  }
`;

export const CheckboxFilledLabel = styled.div<StyledCheckboxProps>`
  ${({active}: StyledCheckboxProps) => (active ? fontStyles.bodyM : fontStyles.bodyR)}
  width: ${({labelWidth}: StyledCheckboxProps) =>
    labelWidth ? `${labelWidth}%` : '100%'};
`;
